import { apiRequest } from '../helpers'

export interface SharePointSiteInfo {
  id?: string
  siteId: string
  siteUrl: string
  displayName: string
  driveId: string
}

export interface SharePointDriveItem {
  id: string
  name: string
  webUrl?: string
  size?: number
  eTag?: string
  cTag?: string
  lastModifiedDateTime?: string
  folder?: {
    childCount?: number
  }
  file?: {
    mimeType?: string
  }
}

export interface LinkedSharePointFile {
  id: string
  clientId: string
  name: string
  webUrl?: string
  mimeType?: string
  size?: number
  eTag?: string
  cTag?: string
  lastModifiedDateTime?: string
  siteId: string
  driveId: string
  itemId: string
  status: string
  createdAt: string
  createdBy: string
  lastVerifiedAt?: string
  contentHash?: string
  contentHashAlgorithm?: string
  contentHashAt?: string
}

const base = `${process.env.REACT_APP_API_URL}/microsoft/sharepoint`

export async function getSharePointSite(): Promise<{ site: SharePointSiteInfo | null }> {
  return apiRequest(`${base}/site`, 'GET')
}

export async function saveSharePointSite(payload: {
  hostname: string
  relativePath: string
}): Promise<{ site: SharePointSiteInfo }> {
  return apiRequest(`${base}/site`, 'POST', payload)
}

export async function getSharePointRootItems(): Promise<{ items: SharePointDriveItem[] }> {
  return apiRequest(`${base}/root`, 'GET')
}

export async function getSharePointFolderItems(
  itemId: string
): Promise<{ items: SharePointDriveItem[] }> {
  return apiRequest(`${base}/items/${encodeURIComponent(itemId)}/children`, 'GET')
}

export async function linkSharePointFile(payload: {
  clientId: string
  itemId: string
}): Promise<{ ok?: boolean; file?: LinkedSharePointFile }> {
  return apiRequest(`${base}/files`, 'POST', payload)
}

export async function getSharePointFiles(
  clientId: string
): Promise<{ files: LinkedSharePointFile[] }> {
  return apiRequest(`${base}/files/${encodeURIComponent(clientId)}`, 'GET')
}

export async function openSharePointFile(id: string): Promise<{
  file: LinkedSharePointFile
  changed?: boolean
  reviewedETag?: string
  currentETag?: string
}> {
  return apiRequest(`${base}/files/${encodeURIComponent(id)}/open`, 'GET')
}

export async function deleteSharePointFile(id: string): Promise<{ ok?: boolean }> {
  return apiRequest(`${base}/files/${encodeURIComponent(id)}`, 'DELETE')
}

export async function copySharePointFile(id: string): Promise<{ ok?: boolean; fileName?: string }> {
  return apiRequest(`${base}/files/${encodeURIComponent(id)}/copy`, 'POST')
}

export async function hashSharePointFile(
  id: string
): Promise<{ contentHash: string; contentHashAlgorithm: string }> {
  return apiRequest(`${base}/files/${encodeURIComponent(id)}/verify-hash`, 'POST')
}

export async function uploadDocumentToSharePoint(payload: {
  clientId: string
  type: string
  filename: string
  path?: string
}): Promise<{ ok?: boolean; webUrl?: string; name?: string }> {
  return apiRequest(`${base}/upload`, 'POST', payload)
}
